export const firstCharacterName = (firstName, lastName) => {
  const first = firstName?.trim().charAt(0).toUpperCase() || "";
  const last = lastName?.trim().charAt(0).toUpperCase() || "";
  return first + last;
};

export const CharacterName = (name) => {
  const name1 = name?.trim().charAt(0).toUpperCase() || "";

  return name1;
};

export const getTwoCharacterInitials = (name) => {
  if (!name) return "";

  const parts = name.trim().split(" ").filter(Boolean);

  if (parts.length > 1) {
    // Take first char of first two words
    return (
      parts[0].charAt(0).toUpperCase() +
      parts[1].charAt(0).toUpperCase()
    );
  }

  // No space → take first two letters
  return name.trim().substring(0, 2).toUpperCase();
};